import { createReducer, on } from '@ngrx/store';
import { initFeatureFlagSuccess } from '@stores/features-flags/features-flags-ngrx.action';

export const featureFlagsKey = 'featureFlags';

export type FeatureFlagsState = {
  featureFlags?: string[];
};

export const initialState: FeatureFlagsState = { featureFlags: undefined };

export const featureFlagsReducer = createReducer(
  initialState,
  on(initFeatureFlagSuccess, (_, { featureFlags }) => {
    return { featureFlags };
  })
);
